import * as types from "../constants/actionTypes";
import uuidv4 from "uuid/v4";

export const sessionInitialState = {
    terms: null,
    userHasAccepted: false,
    reloadKey: uuidv4(),
    hideTutorialPrompt: true,
    showAutoAALLinkModal: false,
    showInsuranceForm: false,
    showAutoLinkMyChart: false,
    phyndData: null,
    ADGroups: [],
    sameDayCareCheckbox: false,
    adg: [],
    infoForUpdateMobileNo: false
};

export default function sessionReducer(state = sessionInitialState, action) {
    switch (action.type) {
        case types.SET_HEALTH_SOURCE_TOKEN:
            //debugger;
            return {
                ...state,
                adg: action.result.Groups
            };

        case types.LOGOUT:
            return {
                ...state,
                terms: null,
                userHasAccepted: false,
                hideTutorialPrompt: true,
                showAutoAALLinkModal: false,
                showInsuranceForm: false,
                showAutoLinkMyChart: false,
                phyndData: null,
                ADGroups: [],
                sameDayCareCheckbox: false,
                adg: []
            };
        case types.INSTADOC_SET_TOKEN:

            return {
                ...state,
                ADGroups: action.data.adGroups
            }
        case types.SET_PHYND_DATA:
            return {
                ...state,
                phyndData: action.data
            };
        case types.INIT_SESSION:
            // TODO: use with asp-prerender-data to set initial state from the server.
            return state;
        case types.SET_SERVER_DATA:
            return { ...state, serverData: action.serverData };
        case types.SET_HISTORY_OBJECT:
            //debugger;
            return { ...state, history: action.history };
        case types.SET_TERMS_AND_CONDITIONS:
            return { ...state, terms: action.terms || state.terms, version: action.version || state.version, userHasAccepted: action.HasAccepted || state.userHasAccepted};
        case types.SHOW_INSURANCE_FORM:
            return { ...state, showInsuranceForm: action.showInsuranceForm };
        case types.RELOAD_KEY:
            return { ...state, reloadKey: uuidv4() };
        case types.SHOW_INFOFORUPDATEMOBILENO_TOOLTIP:
            return { ...state, infoForUpdateMobileNo: !state.infoForUpdateMobileNo };
        default:
            return { ...state };
    }
}